import React from 'react'
// import { NavLink as Link } from 'react-router-dom'
import Navbar from '../components/Navbar'
import Pattern from '../assets/images/vector.svg'
import CV from '../../src/assets/file/CV.pdf'
import { Hero, Design, Sub, Head, Para, Button, Container } from '../assets/styles/homeElements'

const Home = () => {
    return (
        <>
            <Navbar />
            <Container>
                <Hero>
                    <Sub>Welcome! My name is</Sub>
                    <Head>BHAWESH VERMA</Head>
                    <Para style={{ fontWeight: '400' }}>I’m a Full Stack Web-Developer.<br />It's been 4 years scince I started my journey to become a successful engineer. I have learnt a lot during my journey and made some awesome projects as the implementation of all my learnings.<br />To check my projects, click on <strong>Projects</strong> on top of the Navbar.</Para>
                    <a href={CV} download='CV'>
                        <Button>Download CV</Button>
                    </a>
                    {/* <Link to='/contact'>
                        <Button className='contact'>Contact Me</Button>
                    </Link> */}
                </Hero>
            </Container>
            <Design src={Pattern} />
        </>
    )
}

export default Home